export default [
	{
		reason_code: 'ACM',
		description: 'Agency Commissions',
	},
	{
		reason_code: 'AES',
		description: 'Advance payment against EOS',
	},
	{
		reason_code: 'AFA',
		description: 'Receipts or payments from personal residents bank account or deposits abroad',
	},
	{
		reason_code: 'AFL',
		description: 'Receipts or payments from personal non-resident bank account in the UAE',
	},
	{
		reason_code: 'ALW',
		description: 'Allowance',
	},
	{
		reason_code: 'ATS',
		description: 'Air transport',
	},
	{
		reason_code: 'BON',
		description: 'Bonus',
	},
	{
		reason_code: 'CCP',
		description: 'Corporate Card Payments',
	},
	{
		reason_code: 'CEA',
		description:
			'Equity and investment fund shares for the establishment of new company from residents abroad, equity of merger or acquisition of companies abroad from residents and participation to capital increase of related companies abroad',
	},
	{
		reason_code: 'CEL',
		description:
			'Equity and investment fund shares for the establishment of new company in the UAE from non-residents, equity of merger or acquisition of companies in the UAE from non-residents and participation to capital increase of related companies from non-residents in the UAE',
	},
	{
		reason_code: 'CHC',
		description: 'Charitable Contributions (Charity and Aid)',
	},
	{
		reason_code: 'CIN',
		description: 'Commercial Investments',
	},
	{
		reason_code: 'COM',
		description: 'Commission',
	},
	{
		reason_code: 'COP',
		description: 'Compensation',
	},
	{
		reason_code: 'CRP',
		description: 'Credit Card Payment',
	},
	{
		reason_code: 'DCP',
		description: 'Debit Card Payments',
	},
	{
		reason_code: 'DIV',
		description: 'Dividend Payouts From FI',
	},
	{
		reason_code: 'DLA',
		description: 'Purchases and sales of foreign debt securities in not related companies - More than a year',
	},
	{
		reason_code: 'DLF',
		description: 'Debt instruments intragroup loans, deposits foreign (above 10% share)',
	},
	{
		reason_code: 'DLL',
		description: 'Purchases and sales of securities issued by residents in not related companies - More than a year',
	},
	{
		reason_code: 'DOE',
		description: 'Dividends on equity not intragroup',
	},
	{
		reason_code: 'DSA',
		description: 'Purchases and sales of foreign debt securities in not related companies - Less than a year',
	},
	{
		reason_code: 'DSF',
		description: 'Debt instruments intragroup foreign securities',
	},
	{
		reason_code: 'DSL',
		description: 'Purchases and sales of securities issued by residents in not related companies - Less than a year',
	},
	{
		reason_code: 'EDU',
		description: 'Educational Support',
	},
	{
		reason_code: 'EMI',
		description: 'Equated Monthly Installments',
	},
	{
		reason_code: 'EOS',
		description: 'End of Service / Final Settlem',
	},
	{
		reason_code: 'FAM',
		description: "Family Support (Workers' remittances)",
	},
	{
		reason_code: 'FDA',
		description: 'Financial derivatives foreign',
	},
	{
		reason_code: 'FDL',
		description: 'Financial derivatives in the UAE',
	},
	{
		reason_code: 'FIA',
		description: 'Investment fund shares foreign',
	},
	{
		reason_code: 'FIL',
		description: 'Investment fund shares in the UAE',
	},
	{
		reason_code: 'FIS',
		description: 'Financial services',
	},
	{
		reason_code: 'FSA',
		description: 'Equity other than investment fund shares in not related companies abroad',
	},
	{
		reason_code: 'FSL',
		description: 'Equity other than investment fund shares in not related companies in the UAE',
	},
	{
		reason_code: 'GDE',
		description: 'Goods sold (Exports in fob value)',
	},
	{
		reason_code: 'GDI',
		description: 'Goods bought (Imports in cif value)',
	},
	{
		reason_code: 'GMS',
		description: 'Processing repair and maintenance services on goods',
	},
	{
		reason_code: 'GOS',
		description: 'Government goods and services embassies etc',
	},
	{
		reason_code: 'GRI',
		description: 'Government related income taxes, tariffs, capital transfers, etc',
	},
	{
		reason_code: 'IFS',
		description: 'Information services',
	},
	{
		reason_code: 'IGD',
		description: 'Dividends intragroup',
	},
	{
		reason_code: 'IGT',
		description: 'INTER GROUP TRANSFER',
	},
	{
		reason_code: 'IID',
		description: 'Interest on debt intragroup',
	},
	{
		reason_code: 'INS',
		description: 'Insurance services',
	},
	{
		reason_code: 'IOD',
		description: 'Income on deposits',
	},
	{
		reason_code: 'IOL',
		description: 'Income on loans',
	},
	{
		reason_code: 'IPC',
		description: 'Charges for the use of intellectual property royalties',
	},
	{
		reason_code: 'IPO',
		description: 'IPO Subscriptions',
	},
	{
		reason_code: 'IRP',
		description: 'INTEREST RATE SWAP PAYMENTS',
	},
	{
		reason_code: 'IRW',
		description: 'INTERST RATE UNWIND PAYMENTS',
	},
	{
		reason_code: 'ISH',
		description: 'Income on investment funds shares',
	},
	{
		reason_code: 'ISL',
		description: 'Interest on securities more than a year',
	},
	{
		reason_code: 'ISS',
		description: 'Interest on securities less than a year',
	},
	{
		reason_code: 'ITS',
		description: 'Computer services',
	},
	{
		reason_code: 'LAS',
		description: 'Leave Salary',
	},
	{
		reason_code: 'LDL',
		description: 'Debt instruments intragroup loans, deposits in the UAE (above 10% share)',
	},
	{
		reason_code: 'LDS',
		description: 'Debt instruments intragroup securities in the UAE',
	},
	{
		reason_code: 'LEA',
		description: 'Leasing abroad',
	},
	{
		reason_code: 'LEL',
		description: 'Leasing in the UAE',
	},
	{
		reason_code: 'LIP',
		description: 'Loan Interest Payments',
	},
	{
		reason_code: 'LLA',
		description: 'Loans ? Drawings or Repayments on loans extended to nonresidents - Long-term',
	},
	{
		reason_code: 'LLL',
		description: 'Loans - Drawings or Repayments on foreign loans extended to residents - Long-term',
	},
	{
		reason_code: 'LNC',
		description: 'Loan Charges',
	},
	{
		reason_code: 'LND',
		description: 'Loan Disbursements From FI',
	},
	{
		reason_code: 'MCR',
		description: 'Monetary Claim Reimbursements',
	},
	{
		reason_code: 'MWI',
		description: 'MOBILE WALLET CARD CASH-IN',
	},
	{
		reason_code: 'MWO',
		description: 'MOBILE WALLET CARD CASH-OUT',
	},
	{
		reason_code: 'MWP',
		description: 'MOBILE WALLET CARD PAYMENTS',
	},
	{
		reason_code: 'OAT',
		description: 'OWN ACCOUNT TRNSFER',
	},
	{
		reason_code: 'OTS',
		description: 'Other modes of transport (including Postal and courier services)',
	},
	{
		reason_code: 'OVT',
		description: 'Overtime',
	},
	{
		reason_code: 'PEN',
		description: 'Pension',
	},
	{
		reason_code: 'PIN',
		description: 'Personal Investments',
	},
	{
		reason_code: 'PIP',
		description: 'Profits on Islamic products',
	},
	{
		reason_code: 'PMS',
		description: 'Professional and management consulting services',
	},
	{
		reason_code: 'POR',
		description: 'Refunds/Reversals on IPO subscriptions',
	},
	{
		reason_code: 'POS',
		description: 'POS Merchant Settlement',
	},
	{
		reason_code: 'PPA',
		description: 'Purchase of real estate abroad from residents',
	},
	{
		reason_code: 'PPL',
		description: 'Purchase of real estate in the UAE from non-residents',
	},
	{
		reason_code: 'PRP',
		description: 'PROFIT RATE SWAP PAYMENTS',
	},
	{
		reason_code: 'PRR',
		description: 'Profits or rents on real estate',
	},
	{
		reason_code: 'PRS',
		description: 'Personal, cultural, audiovisual and recreational services',
	},
	{
		reason_code: 'PRW',
		description: 'PROFIT RATE UNWIND PAYMENTS',
	},
	{
		reason_code: 'RDA',
		description: 'Reverse debt instruments abroad',
	},
	{
		reason_code: 'RDL',
		description: 'Reverse debt instruments in the UAE',
	},
	{
		reason_code: 'RDS',
		description: 'Research and development services',
	},
	{
		reason_code: 'REA',
		description: 'Reverse equity share abroad',
	},
	{
		reason_code: 'REL',
		description: 'Reverse equity share in the UAE',
	},
	{
		reason_code: 'RFS',
		description: 'Repos on foreign securities',
	},
	{
		reason_code: 'RLS',
		description: 'Repos on securities issued by residents',
	},
	{
		reason_code: 'RNT',
		description: 'Rent Payments',
	},
	{
		reason_code: 'SAA',
		description: 'Salary Advance',
	},
	{
		reason_code: 'SAL',
		description: 'Salary (Compensation of employees)',
	},
	{
		reason_code: 'SCO',
		description: 'Construction',
	},
	{
		reason_code: 'SLA',
		description: 'Loans ? Drawings or Repayments on loans extended to nonresidents - Short-term',
	},
	{
		reason_code: 'SLL',
		description: 'Loans - Drawings or Repayments on foreign loans extended to residents - Short-term',
	},
	{
		reason_code: 'STR',
		description: 'Travel',
	},
	{
		reason_code: 'STS',
		description: 'Sea transport',
	},
	{
		reason_code: 'SVI',
		description: 'STORED VALUE CARD CASH-IN',
	},
	{
		reason_code: 'SVO',
		description: 'STORED VALUE CARD CASH-OUT',
	},
	{
		reason_code: 'SVP',
		description: 'STORED VALUE CARD PAYMENTS',
	},
	{
		reason_code: 'TCP',
		description: 'Trade credits and advances payable',
	},
	{
		reason_code: 'TCR',
		description: 'Trade credits and advances receivable',
	},
	{
		reason_code: 'TCS',
		description: 'Telecommunication services',
	},
	{
		reason_code: 'TKT',
		description: 'Tickets',
	},
	{
		reason_code: 'TOF',
		description: 'Transfer of funds between persons Normal and Juridical',
	},
	{
		reason_code: 'TTS',
		description: 'Technical, trade-related and other business services',
	},
	{
		reason_code: 'UFP',
		description: 'Unclaimed Funds Placement',
	},
	{
		reason_code: 'UTL',
		description: 'Utility Bill Payments',
	},
];
